"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.Lookup = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var ui_common_1 = require("@codametrix/ui-common");
var ui_components_1 = require("@codametrix/ui-components");
var show_results_1 = require("../../transactions/transaction/show-results");
var elements_1 = require("../../../utils/elements");
var verdigris_1 = require("@codametrix/verdigris");
var defaultSearchContext = function () { return ({
    codeType: null
}); };
var draggedCodesManager = ui_common_1.dragManager.load('codes');
var resultFormatter = function (activeIdx, result, idx) {
    var styleClasses = [
        'search-result',
        "".concat(result.codeType.toLowerCase(), "-code"),
        { 'search-result-submittable': activeIdx === idx }
    ];
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ "data-idx": idx, className: (0, classnames_1["default"])(styleClasses), draggable: true, "data-dd-action-name": "~Select code (".concat(result.codeType.toLowerCase(), "-code)") }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: "col-label search-label" }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "left-components" }, { children: (0, jsx_runtime_1.jsx)("span", __assign({ className: "code-gripper" }, { children: (0, jsx_runtime_1.jsx)(verdigris_1.BiomeIcon, { iconName: verdigris_1.IconName.Gripper, iconClass: "gripper" }) })) })), (0, jsx_runtime_1.jsx)("div", __assign({ className: "right-components" }, { children: (0, jsx_runtime_1.jsx)("span", __assign({ className: "code-chip" }, { children: (0, jsx_runtime_1.jsx)("span", __assign({ className: "chip" }, { children: result.code })) })) }))] })), (0, jsx_runtime_1.jsx)("div", __assign({ className: "col-code-description" }, { children: result.description }))] }), idx));
};
var getSelectionData = function (row, selectElement, items, searchBarContext) {
    var _a, _b;
    var code = row.querySelector('.chip').innerHTML;
    var description = row.querySelector('.col-code-description').innerHTML;
    var codeType = (selectElement === null || selectElement === void 0 ? void 0 : selectElement.value) ||
        searchBarContext.codeType;
    var searchSelection = {
        code: code,
        description: description,
        codeType: codeType,
        effectiveDate: '',
        shortDescription: '',
        tenantDefined: false,
        modifierType: items.find(function (item) { return item.code === code; }).modifierType || null,
        customCpt: (_b = (_a = items.find(function (item) { return item.code === code; })) === null || _a === void 0 ? void 0 : _a.customCpt) !== null && _b !== void 0 ? _b : false
    };
    return searchSelection;
};
var placeholderResult = function (text, FieldDefinitions) {
    var styleClasses = ['search-result'];
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: (0, classnames_1["default"])(styleClasses) }, { children: [FieldDefinitions.length > 0 && ((0, jsx_runtime_1.jsx)("div", { className: "col-label search-label" })), (0, jsx_runtime_1.jsx)("div", __assign({ className: "col-code-description" }, { children: text }))] })));
};
var suppressEnterKey = function (ev) {
    // in the case of this component being wrapped by a from, for submit,
    // the form looks for the keydown event in order to submit.  For the lookup
    // form we don't want it to trigger a submit at all.
    if (ev.key === 'Enter') {
        ev.preventDefault();
    }
};
var Lookup = /** @class */ (function (_super) {
    __extends(Lookup, _super);
    function Lookup(props) {
        var _this = _super.call(this, props) || this;
        _this.calculatePosition = function () {
            var _a;
            if (_this.searchRef.current && _this.resultRef.current) {
                var _b = (_a = _this.searchRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect(), top_1 = _b.top, bottom = _b.bottom;
                var viewportHeight = window.innerHeight;
                var newPosition = 'bottom';
                // Calculate available space above and below the dropdown
                var spaceAbove = top_1;
                var spaceBelow = viewportHeight - bottom;
                if (_this.state.resultHeight) {
                    if (spaceBelow >= _this.state.resultHeight) {
                        newPosition = 'bottom';
                    }
                    else if (spaceAbove >= _this.state.resultHeight) {
                        newPosition = 'top';
                    }
                    _this._setState({ searchResultPosition: newPosition });
                }
            }
        };
        _this.handleResize = function () {
            _this.calculatePosition();
        };
        _this.handleSearchSelection = _this.handleSearchSelection.bind(_this);
        _this.handleSearchBarFocus = _this.handleSearchBarFocus.bind(_this);
        _this.handleSearchChange = _this.handleSearchChange.bind(_this);
        _this.onSubmit = _this.onSubmit.bind(_this);
        _this.handleKeyPress = _this.handleKeyPress.bind(_this);
        _this.handleDragStart = _this.handleDragStart.bind(_this);
        _this._detectClickOutside = _this._detectClickOutside.bind(_this);
        _this.handleResize = _this.handleResize.bind(_this);
        _this.calculatePosition = _this.calculatePosition.bind(_this);
        var WithResults = _this.props.searchResults.length > 0;
        _this.state = {
            active: WithResults,
            autocompleteEntry: props.searchResults.length ? 0 : -1,
            resultsActive: WithResults,
            showResults: WithResults,
            selecting: false,
            searching: false,
            codeQuery: {},
            searchResultPosition: 'bottom',
            resultHeight: 0,
            searchBarContext: defaultSearchContext()
        };
        _this.wrapperRef = react_1["default"].createRef();
        _this.resultRef = react_1["default"].createRef();
        _this.searchRef = react_1["default"].createRef();
        _this.handleDragEnd = _this.handleDragEnd.bind(_this);
        if (_this.props.autoBlur) {
            document.addEventListener('click', _this._detectClickOutside);
        }
        if (_this.props.debounceTimeout > 0) {
            var origSearch = _this.handleSearch.bind(_this);
            _this.handleSearch = ui_common_1.objectUtils.debounce(origSearch, _this.props.debounceTimeout);
        }
        return _this;
    }
    Lookup.prototype.componentDidMount = function () {
        window.addEventListener('resize', this.handleResize.bind(this));
    };
    Lookup.prototype.componentWillUnmount = function () {
        window.removeEventListener('resize', this.handleResize.bind(this));
    };
    /**
     * Calls onSearch.
     * @param codeQuery
     */
    Lookup.prototype.handleSearch = function (codeQuery) {
        codeQuery.context = __assign(__assign({}, codeQuery.context), { meetsMinimum: codeQuery.text.length > this.props.minLength });
        if (codeQuery.context.meetsMinimum) {
            this._setState({
                codeQuery: codeQuery,
                searching: true,
                showResults: this.props.searchResults.length > 0
            });
        }
        this.props.onSearch(codeQuery);
    };
    Lookup.prototype.scrollResultIfNeeded = function () {
        var activeResult = this.resultRef.current.querySelector('.search-result-submittable');
        if (activeResult) {
            var visibility = (0, elements_1.isElementVisible)(activeResult, this.resultRef.current);
            if (!visibility.contained) {
                if (visibility.below) {
                    // only partial support for IE
                    // https://caniuse.com/scrollintoview
                    activeResult.scrollIntoView({
                        block: 'end',
                        behavior: 'smooth',
                        inline: 'nearest'
                    });
                }
                else {
                    activeResult.scrollIntoView({
                        block: 'start',
                        behavior: 'smooth',
                        inline: 'nearest'
                    });
                }
            }
        }
    };
    Lookup.prototype.handleKeyPress = function (ev) {
        var autocompleteEntry = this.state.autocompleteEntry;
        var searchResultsLength = this.props.searchResults.length;
        if (searchResultsLength) {
            var updated = autocompleteEntry;
            if (ev.key === 'ArrowDown') {
                // down behavior - stops at the last element, does not wrap around to the top
                this.setState({
                    autocompleteEntry: Math.min(++updated, searchResultsLength - 1)
                });
                // rAF available in IE 10 https://developer.mozilla.org/en-US/docs/Web/API/window/requestAnimationFrame#browser_compatibility
                requestAnimationFrame(this.scrollResultIfNeeded.bind(this));
            }
            else if (ev.key === 'ArrowUp') {
                // up behavior - goes up to the top element, does not wrap around to the bottom.
                this.setState({ autocompleteEntry: Math.max(--updated, 0) });
                requestAnimationFrame(this.scrollResultIfNeeded.bind(this));
            }
            else if (ev.key === 'Enter') {
                var searchResult = this.resultRef.current.querySelector('.search-result-submittable');
                if (searchResult.classList.contains('result-unselectable')) {
                    return;
                }
                else {
                    // selection
                    ev.stopPropagation();
                    ev.preventDefault();
                    var searchSelection = this.props.searchResults[this.state.autocompleteEntry];
                    this.props.onSearchSelection(searchSelection);
                    // reset the controls.
                    this.searchRef.current.reset();
                    this._setState({
                        active: false,
                        showResults: false,
                        selecting: false,
                        searching: false,
                        codeQuery: {
                            text: ''
                        }
                    });
                    this.focus();
                }
            }
        }
    };
    Lookup.prototype.handleDragStart = function (ev) {
        var idx = ev.target.attributes.getNamedItem('data-idx');
        if (idx !== null) {
            var value = parseInt(idx.value);
            var item = __assign({}, this.props.searchResults[value]);
            draggedCodesManager.set(item);
            ev.dataTransfer.setData('text', JSON.stringify(item));
        }
    };
    Lookup.prototype.handleDragEnd = function (ev) {
        draggedCodesManager.clear();
        // someone may have dragged a code off to nowhere of importance
        // if the code was dragged and it was important we clear the controls
        if (ev.dataTransfer.dropEffect !== 'none') {
            this.searchRef.current.reset();
        }
    };
    Lookup.prototype.reset = function () {
        if (this.searchRef) {
            this.searchRef.current.reset();
        }
        this.setState({
            resultsActive: false,
            showResults: false,
            selecting: false,
            searching: false,
            codeQuery: {}
        });
    };
    Lookup.prototype.focus = function () {
        if (this.searchRef.current) {
            this.searchRef.current.focus();
        }
    };
    Lookup.prototype._detectClickOutside = function (ev) {
        if (this.props.autoBlur) {
            var target = ev === null || ev === void 0 ? void 0 : ev.target;
            if (target instanceof HTMLElement && this.wrapperRef.current !== null) {
                var outOfScope = !this.wrapperRef.current.contains(target);
                if (outOfScope) {
                    this._setState({
                        searching: false,
                        showResults: false,
                        active: false
                    });
                }
            }
        }
    };
    Lookup.prototype.handleSearchChange = function (event) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        if (this.props.autoSearch) {
            var evValues = (_a = event.detail.value) !== null && _a !== void 0 ? _a : { value: '', key: '' };
            var codeQuery = {
                text: evValues.value,
                searchType: evValues.key,
                searchResultsLookupKey: this.props.searchResultsLookupKey
            };
            if (((_c = (_b = event === null || event === void 0 ? void 0 : event.detail) === null || _b === void 0 ? void 0 : _b.value) === null || _c === void 0 ? void 0 : _c.eventSource) === 'dropdown') {
                codeQuery.text = '';
                this.state.codeQuery.text = '';
                this.searchRef.current.reset();
            }
            var showResults = (0, show_results_1.matchRequirements)(codeQuery);
            if (!showResults) {
                this._setState({
                    searching: false,
                    showResults: false,
                    active: true,
                    codeQuery: codeQuery,
                    searchBarContext: __assign(__assign({}, this.state.searchBarContext), { codeType: (_e = (_d = event === null || event === void 0 ? void 0 : event.detail) === null || _d === void 0 ? void 0 : _d.value) === null || _e === void 0 ? void 0 : _e.key })
                });
            }
            else if (showResults && !this.state.searching) {
                this._setState({
                    searching: true,
                    showResults: true,
                    active: true,
                    codeQuery: codeQuery,
                    searchBarContext: __assign(__assign({}, this.state.searchBarContext), { codeType: (_g = (_f = event === null || event === void 0 ? void 0 : event.detail) === null || _f === void 0 ? void 0 : _f.value) === null || _g === void 0 ? void 0 : _g.key })
                });
            }
            else {
                this._setState({
                    searching: true,
                    showResults: true,
                    active: true,
                    codeQuery: codeQuery,
                    searchBarContext: __assign(__assign({}, this.state.searchBarContext), { codeType: (_j = (_h = event === null || event === void 0 ? void 0 : event.detail) === null || _h === void 0 ? void 0 : _h.value) === null || _j === void 0 ? void 0 : _j.key })
                });
            }
            this.handleSearch(codeQuery);
        }
    };
    Lookup.prototype.onSubmit = function (event) {
        var _a;
        var evValues = (_a = event.detail.value) !== null && _a !== void 0 ? _a : { value: '', key: '' };
        var codeQuery = { text: evValues.value, searchType: evValues.key };
        this.handleSearch(codeQuery);
        if (!this.props.autoSearch) {
            this._setState({
                searching: true,
                showResults: true,
                active: true,
                codeQuery: codeQuery
            });
        }
    };
    Lookup.prototype.componentDidUpdate = function (prevProps) {
        var _a, _b;
        var searchResults = this.props.searchResults;
        var previousSearchResults = prevProps.searchResults;
        var codeQuery = this.state.codeQuery;
        if (searchResults !== previousSearchResults) {
            // if a new result comes in we want to reset the scroll position
            // of the results so that it comes back to the top.
            var height = (_b = (_a = this.resultRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect()) === null || _b === void 0 ? void 0 : _b.height;
            this._setState({
                resultHeight: height
            });
            if (this.state.showResults && this.resultRef.current) {
                this.resultRef.current.scrollTop = 0;
            }
            var autocompleteEntry = searchResults.length ? 0 : -1;
            if (this.state.searching && "".concat(codeQuery.text).length > 1) {
                this._setState({
                    autocompleteEntry: autocompleteEntry,
                    searching: false,
                    showResults: true,
                    resultsActive: true
                });
            }
        }
    };
    Lookup.prototype._setState = function (s) {
        this.setState(function (state) {
            return __assign(__assign({}, state), s);
        });
    };
    Lookup.prototype.handleSearchBarFocus = function (ev) {
        var _this = this;
        if (!this.state.active) {
            // The focus event fires after the SearchBar change event, but
            // in the same thread afaict.
            // What this means in practice is that calls to get and set
            // state can have unwanted effects.  Since React's setState queues
            // changes, the desired changes can be overridden if they happen
            // in succession.  By running the call in the next `tick`, then
            // the changes that we're looking for, do not get clobbered.
            setTimeout(function () {
                var showResults = Array.isArray(_this.props.searchResults);
                _this._setState({ showResults: showResults, active: true });
            }, 0);
        }
    };
    Lookup.prototype.handleSearchSelection = function (ev) {
        ev.preventDefault();
        var row = ev.target.closest('.search-result');
        var selectElement = this.props.FieldDefinitions.length > 0
            ? this.wrapperRef.current.querySelector('select')
            : null;
        var selectElementOrCodeType = selectElement || this.state.searchBarContext.codeType;
        if (row &&
            (selectElementOrCodeType || this.props.FieldDefinitions.length === 0)) {
            var searchSelection = this.props.getSelectionData(row, selectElement, this.props.searchResults, this.state.searchBarContext);
            this.props.onSearchSelection(searchSelection);
            this.searchRef.current.reset();
            this._setState({
                active: false,
                showResults: false,
                selecting: false,
                searching: false,
                codeQuery: {
                    text: ''
                }
            });
            var textInput = this.wrapperRef.current.querySelector('input.form-input');
            if (textInput) {
                textInput.focus();
            }
        }
    };
    Lookup.prototype.render = function () {
        var _a, _b;
        var _c = this.props, onSearch = _c.onSearch, searchResults = _c.searchResults, onSearchSelection = _c.onSearchSelection, autoFocus = _c.autoFocus, autoBlur = _c.autoBlur, shouldShowResults = _c.shouldShowResults, FieldDefinitions = _c.FieldDefinitions, placeholderText = _c.placeholderText, actionPrefix = _c.actionPrefix, autoSearch = _c.autoSearch, resultFormatter = _c.resultFormatter, getSelectionData = _c.getSelectionData, debounceTimeout = _c.debounceTimeout, showSearchButton = _c.showSearchButton, actionNameForDD = _c.actionNameForDD, rest = __rest(_c, ["onSearch", "searchResults", "onSearchSelection", "autoFocus", "autoBlur", "shouldShowResults", "FieldDefinitions", "placeholderText", "actionPrefix", "autoSearch", "resultFormatter", "getSelectionData", "debounceTimeout", "showSearchButton", "actionNameForDD"]);
        var state = this.state;
        var showResults = shouldShowResults(state);
        var styleClasses = [
            'lookup',
            {
                'is-active': this.state.active,
                'is-searching': this.state.searching,
                'is-selecting': this.state.selecting,
                'show-results': showResults,
                'has-search-results': showResults && searchResults.length > 0
            }
        ];
        var results;
        if (showResults && searchResults.length > 0) {
            var boundResults = resultFormatter.bind(null, this.state.autocompleteEntry);
            results = searchResults.map(boundResults);
        }
        else if (state.searching) {
            results = placeholderResult('Searching...', FieldDefinitions);
        }
        else if (showResults) {
            results = placeholderResult("No results found for '".concat((_b = (_a = this.state.codeQuery) === null || _a === void 0 ? void 0 : _a.text) !== null && _b !== void 0 ? _b : '', "'"), FieldDefinitions);
        }
        return ((0, jsx_runtime_1.jsxs)("div", __assign({}, rest, { onKeyDown: suppressEnterKey, onFocus: this.handleSearchBarFocus, ref: this.wrapperRef, className: (0, classnames_1["default"])(styleClasses) }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "search-cols" }, { children: (0, jsx_runtime_1.jsx)(ui_components_1.SearchBar, { ref: this.searchRef, flex: true, disabled: this.props.disabled, actionPrefix: this.props.actionPrefix, autoFocus: autoFocus, onKeyPress: this.handleKeyPress, onChange: this.handleSearchChange, onSubmit: this.onSubmit, FieldDefinitions: FieldDefinitions, placeholder: this.props.placeholderText, showSearchButton: this.props.showSearchButton, actionNameForDD: this.props.actionNameForDD, searchBarViewVersion: this.props.SearchBarViewVersion }) })), (0, jsx_runtime_1.jsx)("div", __assign({ ref: this.resultRef, className: "search-results  ".concat(this.state.searchResultPosition), onDragStart: this.handleDragStart, onDragEnd: this.handleDragEnd, onClick: this.handleSearchSelection }, { children: results }))] })));
    };
    Lookup.displayName = 'Lookup';
    Lookup.defaultProps = {
        autoFocus: false,
        autoBlur: true,
        autoSearch: true,
        actionPrefix: 'Add',
        debounceTimeout: 0,
        placeholderText: 'Search for code',
        minLength: 2,
        FieldDefinitions: [],
        showSearchButton: true,
        resultFormatter: resultFormatter,
        getSelectionData: getSelectionData,
        shouldShowResults: function (codeQuery) { return true; },
        onSearchSelection: function (searchSelection) { },
        onSearch: function (codeQuery) { },
        actionNameForDD: '~Focus code search',
        searchBarViewVersion: 'SearchBarView1',
        searchBarContext: defaultSearchContext
    };
    return Lookup;
}(react_1["default"].Component));
exports.Lookup = Lookup;
//# sourceMappingURL=lookup.js.map